import {useEffect, useRef} from 'react';
import store, { useAppSelector, useAppDispatch, rootActions } from '../data/store';
import {
    refresh, deepLinkAndStorageInit,
    initEqualHeight
} from '../services/artists-page-provider';
import { IArtistItem } from '../interfaces/interfaces';
import { useWindowResizeObserver } from '../../../../domain/animations/animations-provider';
import ArtistsContent from "../content/artists-content";

/**
 * List page app.
 */
const ArtistPage = () => {
    const dispatch = useAppDispatch();
    const artists = useAppSelector(store => store.artists);
    const layoutMode = useAppSelector(store => store.layoutMode);
    const filterTerm = useAppSelector(store => store.filterTerm);
    const currentPage = useAppSelector(store => store.currentPage);
    const itemsPerPage = useAppSelector(store => store.itemsPerPage);
    const category = useAppSelector(store => store.category);

    const [ width ] = useWindowResizeObserver();

    const containerRef = useRef<HTMLDivElement>(null);

    /**
     * set deep link, storage, and initial data on page load
     */
    useEffect(() => {

        (async () => {

            const updated = {...store.getState()};

            // get data from deep link hash + session storage on page load
            // and push into the state on page load
            deepLinkAndStorageInit(updated);

            // apply jPlist on the state, and change deep link accordingly
            const res = refresh(updated, true);

            updated.artists = (res.artists || []) as IArtistItem[];
            updated.pagination = res.pagination;

            /*// update the state
            dispatch(rootActions.main(updated));*/


            // update the state
            dispatch(rootActions.refresh(updated));

        })();

    }, [dispatch]);

    /**
     * titles and taglines should have equal height in grid view
     */
    useEffect(() => {
        (async () => {
            await initEqualHeight(containerRef.current, width, layoutMode);
        })();
    }, [
        // update on every jPList action changes,
        // on document width change, and on products change
        width, artists,
        layoutMode, filterTerm,
        currentPage, itemsPerPage,category
    ]);

    return (
        <div>
            {/*<ArtistTopContentContainer/>*/}
            <div className="text-base text-gray-700 my-4" ref={ containerRef }>
                 <ArtistsContent artists={ artists } width={ width } hasPanels={true} />
            </div>
        </div>
    )
};

export default ArtistPage;